import React from 'react'
import MergeSiteDescription from 'components/MergeSiteDescription'
import Loading from 'components/Loading/Loading'
import FormikInputField from 'components/FormikInputField'
import PropTypes from 'prop-types'
import {
  MERGE_SITE_TOOL_TITLE,
  MERGE_TOOL_RULES_TITLE,
  MERGE_TOOL_RULES_FAMILY_ACCESS,
  MERGE_TOOL_RULES_LICENSES,
  MERGE_TOOL_RULES_PREFERENCES,
  MERGE_TOOL_RULES_ROSTERING,
  MERGE_TOOL_RULES_USERS,
  TOOL_DESCRIPTION,
} from './constants'
import {
  Divider,
  MergeSiteButton,
  MergeSiteColumnWrapper,
  MergeSiteLayoutSection,
  MergeSiteInputSection,
  MergeSiteLayoutWrapper,
  MergeSiteColumnTitle,
} from './styles'

const MergeSiteLayout = (props) => {
  const { mergeSiteResults, isSubmitting } = props.mergeSiteState || {}
  const results = mergeSiteResults 
  const isPreview = results && results.isPreview
  return (
    <MergeSiteLayoutWrapper>
      <Loading isLoading={isSubmitting} message="One Moment Please...." />
        <MergeSiteLayoutSection>
          <h2>{MERGE_SITE_TOOL_TITLE}</h2>
          <hr />
          <h3>Tool Description</h3>
          <p>{TOOL_DESCRIPTION}</p>
          <h4>{MERGE_TOOL_RULES_TITLE}</h4>
          <ul>
            <li>
              <b>Users:</b> {MERGE_TOOL_RULES_USERS}
            </li>
            <li>
              <b>Licenses:</b> {MERGE_TOOL_RULES_LICENSES}
            </li>
            <li>
              <b>Preferences:</b> {MERGE_TOOL_RULES_PREFERENCES}
            </li>
            <li>
              <b>Rostering:</b> {MERGE_TOOL_RULES_ROSTERING}
            </li>
            <li>
              <b>Family Access:</b> {MERGE_TOOL_RULES_FAMILY_ACCESS}
            </li>
          </ul>
          <MergeSiteInputSection>
            <div>
              <legend>Site</legend>
              <FormikInputField
                inputName="siteId"
                label="Duplicate Site ID:"
                name="siteId"
                type="number"
                value="siteId"
                {...props}
              />
            </div>
            <div>
              <legend>Merge into:</legend>
              <FormikInputField
                inputName="primarySiteId"
                label="Primary Site ID:"
                name="primarySiteId"
                type="number"
                value="primarySiteId"
                {...props}
              />
            </div>
          </MergeSiteInputSection>
        </MergeSiteLayoutSection>
      {results && (
        <React.Fragment>
          <Divider />
          <legend>{isPreview ? 'Review Merge Results Before Submit' : 'Merge Results'}</legend>
          <MergeSiteLayoutWrapper>
            <div>
              <MergeSiteLayoutSection>
                <MergeSiteColumnWrapper>
                  <MergeSiteColumnTitle>Duplicate Site:</MergeSiteColumnTitle>
                  <MergeSiteDescription 
                    site={results.duplicateSite}
                    siteUserCount={results.duplicateSiteUserCount}
                  />
                </MergeSiteColumnWrapper>
              </MergeSiteLayoutSection>
              <Divider />
            </div>
            <div>
              <MergeSiteLayoutSection>
                <MergeSiteColumnWrapper>
                  <MergeSiteColumnTitle>Primary Site:</MergeSiteColumnTitle>
                  <MergeSiteDescription 
                    site={results.primarySite} 
                    siteUserCount={results.primarySiteUserCount}
                  />
                </MergeSiteColumnWrapper>
              </MergeSiteLayoutSection>
              <Divider />
            </div>
            <div>
              <MergeSiteLayoutSection>
                <MergeSiteColumnWrapper>
                  <MergeSiteColumnTitle>Merged Site:</MergeSiteColumnTitle>
                  <MergeSiteDescription
                    site={results.mergedSite}
                    siteUserCount={results.mergedSiteUserCount}  
                  />
                </MergeSiteColumnWrapper>
              </MergeSiteLayoutSection>
              <Divider/>
            </div>
            
          </MergeSiteLayoutWrapper>
        </React.Fragment>
      )}
      <div>
        <MergeSiteButton
          className="btn-fixed-width"
          color="primary"
          data-testid="merge-site-validate-button"
          disabled={props.enableValidation(props)}
          onClick={() =>
            props.handleValidation(
              props.values,
              props.setSubmitting,
              props.resetForm,
            )
          }
          type="button"
        >
          Validate
        </MergeSiteButton>
        <MergeSiteButton
          className="btn-fixed-width"
          color="primary"
          data-testid="merge-site-cancel-button"
          onClick={() => props.cleanForm(props.resetForm)}
          type="button"
          disabled={ props.values.organizationId === '' 
                    && props.values.nsCustomerId === ''
                    && props.values.siteId === '' }
        >
          Cancel
        </MergeSiteButton>
        <MergeSiteButton
          className="btn-fixed-width"
          color="primary"
          disabled={!props.enableSubmit(props)}
          type="submit"
        >
          Submit
        </MergeSiteButton>
      </div>
    </MergeSiteLayoutWrapper>
  )
}

MergeSiteLayout.propTypes = {
  enableSubmit: PropTypes.func.isRequired,
  enableValidation: PropTypes.func.isRequired,
  handleValidation: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  mergeSiteResults: PropTypes.shape({
    duplicateSite: PropTypes.object,
    duplicateSiteUserCount: PropTypes.number,
    mergedSite: PropTypes.object,
    mergedSiteUserCount: PropTypes.number,
    primarySite: PropTypes.object,
    primarySiteUserCount: PropTypes.number,
  }),
  cleanForm: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  setSubmitting: PropTypes.func.isRequired,
}

export default MergeSiteLayout